import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseReportComponent } from './base-report/base-report.component';
import {
  MatTableModule,
  MatPaginatorModule,
  MatTooltipModule,
  MatSelectModule,
  MatListModule,
  MatCheckboxModule,
  MatInputModule
} from '@angular/material';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';

@NgModule({
  declarations: [BaseReportComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSelectModule,
    MatListModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    SharedComponentsModule
  ],
  exports: [
    BaseReportComponent
  ]
})
export class BaseReportingModule { }
